export default function Photo({
  src,
  alt,
  className = '',
  priority = false,
  sizes,
  contain = false,
}) {
  return (
    <img
      src={src}
      alt={alt}
      sizes={sizes}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : 'auto'}
      decoding={priority ? 'async' : 'async'}
      draggable="false"
      className={`${contain ? 'object-contain' : 'object-cover'} ${contain ? '' : 'photo-lux'} ${className}`}
    />
  );
}
